import React, {useContext, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Sticky from 'react-stickynode';
import { Link, withRouter } from 'react-router-dom';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { ReactSVG } from 'react-svg';

import { AuthContext } from 'context/AuthProvider';

import AuthModal from 'components/UI/AuthModal/AuthModal';
import ScrollBar from 'components/UI/ScrollBar/ScrollBar';

import {
  TobBarWrapper
  // ButtonGroup
} from '../SinglePageView.style';
import { MESSAGES_PAGE } from 'settings/constant';
import messageIcon from 'assets/images/pickapier/message.svg';
import useWindowSize from 'library/hooks/useWindowSize';

// import {
//   FaceBookShare,
//   TwitterShare,
//   LinkedInShare,
//   PinterestShare,
// } from 'components/SocialShare/SocialShare';
// import Button from 'components/UI/Antd/Button/Button';
// import Menu from 'components/UI/Antd/Menu/Menu';
// import Dropdown from 'components/UI/Antd/Dropdown/Dropdown';
// import Favorite from 'components/UI/Favorite/Favorite';

const TopBar = ({ match, location, history, marina }) => {
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const { loggedIn, user, selectBoaterVessel, selectedBoaterVessel } =
    useContext(AuthContext);

  const [authVisible, setAuthVisible] = useState(false);
  const [currPosY, setCurrPosY] = useState(null);

  const topBarMenu = useMemo(() => ([
    {
      name: t('MARINA_TOP_BAR_OVERVIEW'),
      target: 'overview'
    },
    {
      name: t('MARINA_TOP_BAR_AMENITIES'),
      target: 'amenities'
    },
    {
      name: t('MARINA_TOP_BAR_LOCATION'),
      target: 'location'
    },
    {
      name: t('MARINA_TOP_BAR_RESERVATION'),
      target: 'reservation',
      container: 'reservation-container'
    }
  ]), [t]);

  const vesselsWithHomeMarina = user && user.vessels && user.vessels.length
    ? user.vessels.filter(v => v.home_marina_id)
    : [];
  const isHomeMarina = vesselsWithHomeMarina.some(
    ({ home_marina_id }) => home_marina_id === marina.id
  );

  useScrollPosition(({ currPos }) => {
    setCurrPosY(currPos.y);
  });

  const handleClick = () => {
    if (loggedIn) {
      if (selectedBoaterVessel && isHomeMarina) {
        // if the marina is not Home for the selected vessel - select the vessel which belongs to this marina
        const vesselsVerifiedInThisMarina = vesselsWithHomeMarina.filter(
          ({ home_marina_id }) => home_marina_id === marina.id
        );
        if (vesselsVerifiedInThisMarina.length) {
          selectBoaterVessel(vesselsVerifiedInThisMarina[0].id);
        }
      }
      setTimeout(
        () =>
          history.push({
            pathname: `${match.url}${MESSAGES_PAGE}`,
            search: location.search
          }),
        400
      );
    } else {
      setAuthVisible(true);
    }
  };

  if (navigator.userAgent === 'ReactSnap') return <></>;

  const top = width > 991 ? 72 : currPosY < -200 ? 0 : 52;

  return (
    <TobBarWrapper>
      <Sticky innerZ={1000} top={top} activeClass='isSticky'>
        <ScrollBar
          menu={topBarMenu}
          other={
            width > 767 &&
            marina.marina_settings.permissions.chat && (
              <Link
                aria-disabled
                className='message-link'
                onClick={handleClick}
              >
                <ReactSVG className='message-icon' src={messageIcon} />
                {t('MESSAGE_TO_MARINA')}
              </Link>
            )
          }
        />
        <AuthModal
          visible={authVisible}
          title={t('POPUP_SIGNUP_HEADER')}
          onClose={() => setAuthVisible(false)}
        />
      </Sticky>
    </TobBarWrapper>
  );
};

export default withRouter(TopBar);
